// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CalendarContextController from "./calendar_context_controller"
application.register("calendar-context", CalendarContextController)

import CustomerSearchController from "./customer_search_controller"
application.register("customer-search", CustomerSearchController)

import DeviceStatusController from "./device_status_controller"
application.register("device-status", DeviceStatusController)

import EmailDialogController from "./email_dialog_controller"
application.register("email-dialog", EmailDialogController)

import FaceImageController from "./face_image_controller"
application.register("face-image", FaceImageController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import FormPersistenceController from "./form_persistence_controller"
application.register("form-persistence", FormPersistenceController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import QuoteTableController from "./quote_table_controller"
application.register("quote-table", QuoteTableController)

import ScheduleSelectController from "./schedule_select_controller"
application.register("schedule-select", ScheduleSelectController)

import SessionTimeoutController from "./session_timeout_controller"
application.register("session-timeout", SessionTimeoutController)

import SpecDocumentController from "./spec_document_controller"
application.register("spec-document", SpecDocumentController)

import SpecificationListController from "./specification_list_controller"
application.register("specification-list", SpecificationListController)

import SpecificationListRowController from "./specification_list_row_controller"
application.register("specification-list-row", SpecificationListRowController)

import ToggleVisibilityController from "./toggle_visibility_controller"
application.register("toggle-visibility", ToggleVisibilityController)

import ValidateTimeController from "./validate_time_controller"
application.register("validate-time", ValidateTimeController)
